import { Component, Inject, OnInit, } from '@angular/core';
import { downgradeComponent } from '@angular/upgrade/static';
import { WINDOW } from '@ng-web-apis/common';
import { TranslocoService } from '@ngneat/transloco';
import * as tinycolor from 'tinycolor2';
import { NG_ROOT_SCOPE, NG_ROUTER, NG_TRANSITION } from 'webapp/hybrid-helpers/ajs-upgraded-providers';
import { ChartConfigService } from '../../chart/chart-config.service';
import { SessionUser } from '../../models/session-user.model';
import { UserService } from '../../services/user.service';
import { NavStateService } from '../nav-state.service';

declare var $: JQueryStatic

const colorElement = document.querySelector(':root') as Element;
const cssStyles = getComputedStyle(colorElement);

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  /* styleUrls: ['./header.component.scss'],
  host: { class: 'header sticky' },
  encapsulation: ViewEncapsulation.None */
})
export class HeaderComponent implements OnInit {
  headerImages: {
    small: '',
    textImage: ''
  }[] = []

  footerImages

  headerImage = {
    small: '',
    textImage: ''
  }

  currentUser: SessionUser = {} as any
  defaultstyle

  tool: any

  get gravatarUrl() {
    if (!!this.currentUser) {
      return `${this.currentUser.gravatarHashURL}.jpg?s=100&d=mm`
    }
    return undefined
  }

  constructor(
    @Inject(NG_ROUTER) private $state,
    @Inject(NG_ROOT_SCOPE) private $rootScope,
    @Inject(NG_TRANSITION) private $transition,
    @Inject(WINDOW) private window: Window,
    private navState: NavStateService,
    private UserService: UserService,
    private i18n: TranslocoService,
    private chartConfig: ChartConfigService
  ) { }

  ngOnInit(): void {
    this.toolGetSetup()

    this.UserService.getCurrentUser().then(user => {
      this.currentUser = user;
      this.currentUser.isPersonificated = this.UserService.isPersonificated();
      const lang = this.currentUser.language.replace('-', '_');
      this.setupThirdPartyLang(lang)
      this.setupThemeDefaultVariables()
    })
  }

  despersonificate() {
    this.UserService.despersonificate().then((data) => {
      console.info(data);
      //  $location.url('/');
      this.window.location.reload();
    });
  }

  hideMenu() {
    this.navState.toogle()
    //forceResizeWindow();
  }

  setupThirdPartyLang(lang: string) {
    if (lang == 'pt_BR' || lang == 'en_US') {
      this.i18n.setActiveLang(lang);
      if (lang == 'en_US') {
        this.chartConfig.setLanguage(lang)
      }
    } else {
      var arr = lang.split("");
      arr[3] = arr[3].toUpperCase();
      arr[4] = arr[4].toUpperCase();
      lang = arr.join("");
    }
    //@ts-ignore
    $.fn.datetimepicker.dates['br'] = {
      days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"],
      daysMin: ["D", "S", "T", "Q", "Q", "S", "S", "D"],
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      meridiem: '',
      today: "Hoje"
    };
    //@ts-ignore
    $.fn.datepicker.dates['br'] = {
      days: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      daysShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"],
      daysMin: ["D", "S", "T", "Q", "Q", "S", "S", "D"],
      months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      meridiem: '',
      today: "Hoje"
    };
  }

  setupThemeDefaultVariables() {
    const primColor = String(cssStyles.getPropertyValue('--primary-color')).trim();
    const secColor = String(cssStyles.getPropertyValue('--secondary-color')).trim();
    const boardColor = String(cssStyles.getPropertyValue('--sidebar-color')).trim();

    this.defaultstyle = {
      primaryColor: primColor,
      secondaryColor: secColor,
      tertiaryColor: boardColor,
      logoImage: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAYAAACaJFpUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAH/SURBVHgBrdY9TsMwFAfw9xIVCSYWJAQMQQKJMUthdZkKLNygcARuADfgBoQNtrIgJpqZDoSdIQwgRjYqQDV+pYGQ+rv5L03ij1/dOrYBKol3Wby10+rFjM2DZzb3WKe5u30mK8Mq1uDYEw8Jyz7eeStL0zdwxGCICV1zxKR/fXsoBStYESe0jBWpouEI22fzjS+8r2CUxbCB7YWV6PI1zweu2HhE8fJahM+PeUr3wWgYXTECzo8UfcUzs6j9T1XYONncAE5LX+AvzTY7QMQzVUPZz2vERJu01AarNVxQV4wSVGv1b9KEc34o7YLj1TQYJZTVfnnMs6W16EmMdL+Endzd3B5PgynBCbQmjIJgSFO8n/3rNKsDswKL1IFZg3VhlNBUwRaL2yxaXInAtCIFdWEziD3TikTBujDxLCrKdAs+1oyBCQ18MbppADAJRlEu+OiLFXFd8HEazAfFaTFXFOt8qW3QgA+xpeoAgZ/bYpTPAXTFR64oFhMJWCh2he7S+uoqnT0kZFucR3JxHnkAQ2hG0swUlxuyctpjxV57MVratKjYnkxoCYs1WELXv2upL+qC/QN9UFdsAnRBfbBRF6BIc6eViMKOrEzM3iMO2HHFftpqokNV0WEU7Qasf2XcMSPogtpgVqANaotZgzrUBXMCZagr5h2avbQzgEe+AbBy9X3Ag/q6AAAAAElFTkSuQmCC",
      textImage: "data:image/png;base64,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"
    };

    var org = this.currentUser.organizationObj;

    org.styles = org.styles ? org.styles : {}
    org.styles['primaryColor'] = org.styles['primaryColor'] ? org.styles['primaryColor'] : primColor;
    org.styles['secondaryColor'] = org.styles['secondaryColor'] ? org.styles['secondaryColor'] : secColor;
    org.styles['tertiaryColor'] = org.styles['tertiaryColor'] ? org.styles['tertiaryColor'] : boardColor;

    var sheet = (function () {
      // Create the <style> tag
      var style = document.createElement("style");
      // Add a media (and/or media query) here if you'd like!
      // WebKit hack :(
      style.appendChild(document.createTextNode(""));
      // Add the <style> element to the page
      document.body.appendChild(style);
      return style.sheet;
    })() as CSSStyleSheet;
    var rule = `:root{
        --wait-color:` + org.styles['primaryColor'] + `;
        `;
    sheet.insertRule(rule, 0);

    if (org.styles && (org.styles['primaryColor'].toUpperCase() != primColor || org.styles['secondaryColor'].toUpperCase() != secColor || (org.styles['tertiaryColor'].toUpperCase() != primColor && org.styles['tertiaryColor'].toUpperCase() != boardColor))) {
      //Change dashboard colors here
      if (org.styles == null) {
        org.styles = this.defaultstyle;
        var rule = `:root{
            --wait-color:` + org.styles['primaryColor'] + `;
            `;
        sheet.insertRule(rule, 0);
      }
      else {
        var rule = `:root{
            --primary-color:` + org.styles['primaryColor'] + `;
            --secondary-color:` + org.styles['secondaryColor'] + `;
            --lighter-primary:` + tinycolor(org.styles['primaryColor']).setAlpha(0.4).toString() + `;
            --hover1:` + tinycolor(org.styles['primaryColor']).darken().toString() + `;
            --hover2:` + tinycolor(org.styles['secondaryColor']).darken().toString() + `;
            --wait-color:` + org.styles['primaryColor'] + `;
            --trueGreen: #80C342;
            --falseRed: #FF554D;
            `;
        if (org.styles['tertiaryColor'].toUpperCase() != boardColor) {
          rule = rule.concat("--chartColor:" + org.styles['tertiaryColor'] + ";\n");
          rule = rule.concat("--chartColordark:" + tinycolor(org.styles['tertiaryColor']).darken().toString() + ";\n");
          rule = rule.concat("--chartColorlight:" + tinycolor(org.styles['tertiaryColor']).lighten(20).toString() + ";}");
        }
        else {
          rule = rule.concat("--chartColor:" + org.styles['primaryColor'] + ";\n");
          rule = rule.concat("--chartColordark:" + tinycolor(org.styles['primaryColor']).darken().toString() + ";\n");
          rule = rule.concat("--chartColorlight:" + tinycolor(org.styles['primaryColor']).lighten(20).toString() + ";}");
        }
        sheet.insertRule(rule, 0);
        this.headerImages = [
          {
            small: org.styles['logoImage'],
            textImage: org.styles['textImage']
          }
        ];
        this.footerImages = [
          {
            small: "assets/images/custom_icons/powered_by_GA_2019.svg",
            smallImageClass: "",
            textImage: "assets/images/custom_icons/GreenAnt_Logo_Icone.png",
            textImageClass: ""
          }
        ];
      }
    } else if (org.styles && (org.styles['textImage'] && org.styles['logoImage'])) {
      //default headers
      this.headerImages = [
        {
          small: org.styles['logoImage'],
          textImage: org.styles['textImage']
        }
      ];
      if (org.styles['logoImage'] === this.defaultstyle.logoImage) {
        this.footerImages = [];
      }
      else {
        this.footerImages = [
          {
            small: "assets/images/custom_icons/powered_by_GA_2019.svg",
            smallImageClass: "",
            textImage: "assets/images/custom_icons/GreenAnt_Logo_Icone.png",
            textImageClass: ""
          }
        ];
      }
    } else {
      this.headerImages = [
        {
          small: this.defaultstyle.logoImage,
          textImage: this.defaultstyle.textImage
        }
      ];
      this.footerImages = [];
    }
  }

  //TODO: Migrate to be using routerLink
  logout() {
    this.$state.go('logout')
  }

  //TODO: Migrate to be using routerLink
  goToMetersPage() {
    this.$state.go('registrations', { tab: 'dataSources' })
  }

  //TODO: Migrate to be using routerLink
  goToUserPage() {
    this.$state.go('main.user')
  }

  toolGetSetup() {
    const view = this.$state.current.data?.['tools@main']
    this.tool = view
    const vm = this;
    this.$rootScope.$on('$stateChangeSuccess', 
    function(event, toState, toParams, fromState, fromParams, options){
      const view = vm.$state.current.data?.['tools@main'];
      vm.tool = view
    })
    // instanceof Component ? view : undefined
    /* this.$transition.onSuccess({}, (transition) => {
      console.log(transition)
      const state = transition.to()
      const view = state.data?.['tools@main']
      this.tool = view// instanceof Component ? view : undefined
    }) */
  }
}

export const ng2HeaderComponent = {
  name: 'appHeader',
  def: downgradeComponent({ component: HeaderComponent })
}
